import React from 'react'
import { Col, Row } from 'antd'
import { FormikProps } from 'formik'
import { useTranslation } from 'react-i18next'

import { DatePicker, Input, Select } from 'src/components/Formik'
import { Gender } from 'src/types'

import { InitialValues } from '../initial-values'

interface Props {
  formikProps: FormikProps<InitialValues>
}

export default function UserBasic({ formikProps }: Props) {
  const { t } = useTranslation()
  return (
    <>
      <Row gutter={24}>
        <Col span={8}>
          <Input
            formikProps={formikProps}
            label="web.user.common.first_name.title"
            name="first_name"
          />
        </Col>
        <Col span={8}>
          <Input
            formikProps={formikProps}
            label="web.user.common.last_name.title"
            name="last_name"
          />
        </Col>
        <Col span={8}>
          <DatePicker
            formikProps={formikProps}
            label="web.user.common.birthdate.title"
            name="birthdate"
          />
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={8}>
          <Select
            dataTestId="gender-list"
            formikProps={formikProps}
            label="web.user.common.gender.title"
            name="gender"
            options={[
              {
                label: t('web.user.common.gender.M'),
                title: t('web.user.common.gender.M'),
                value: Gender.M
              },
              {
                label: t('web.user.common.gender.F'),
                title: t('web.user.common.gender.F'),
                value: Gender.F
              }
            ]}
          />
        </Col>
        <Col span={8}>
          <Select
            dataTestId="language-list"
            formikProps={formikProps}
            label="web.user.common.preferred_language.title"
            name="preferred_language"
            options={[
              {
                label: 'English',
                title: 'English',
                value: 'EN'
              },
              {
                label: 'Español',
                title: 'Español',
                value: 'ES'
              },
              {
                label: 'Português',
                title: 'Português',
                value: 'PT'
              }
            ]}
          />
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={8}>
          <Input
            formikProps={formikProps}
            label="web.user.common.vat_number.title"
            maxLength={14}
            name="vat_number"
          />
        </Col>
      </Row>
    </>
  )
}
